import { formatIntegerNumber, plainAverage } from '@utils/formatters';

import createColumn from './createColumn';

export const percentageSignal = {
    format: formatIntegerNumber,
    average: plainAverage,
};

export const averageSlopeDown = createColumn({
    key: 'averageSlopeDown',
    dataField: 'averageSlopeDown',
    labelId: 'averageSlopeDown',
    formatter: percentageSignal.format,
    dataSort: true,
});
export const averageSlopeUp = createColumn({
    key: 'averageSlopeUp',
    dataField: 'averageSlopeUp',
    labelId: 'averageSlopeUp',
    formatter: percentageSignal.format,
});

export const foresightedDrivingPercentage = createColumn({
    key: 'foresightedDrivingPercentage',
    type: 'rating',
    dataField: 'foresightedDrivingPercentage',
    labelId: 'foresightedDrivingPercentage',
    formatter: percentageSignal.format,
});

export const foresightedDrivingPercentageV2 = createColumn({
    key: 'foresightedDrivingPercentageV2',
    type: 'rating',
    dataField: 'foresightedDrivingPercentageV2',
    labelId: 'details.rating',
    formatter: percentageSignal.format,
});

export const coastingRating = createColumn({
    key: 'coastingRating',
    type: 'rating',
    dataField: 'coastingRating',
    labelId: 'discipline.coasting',
    formatter: percentageSignal.format,
    icon: 'rioglyph rioglyph-coasting',
    hideLabelOnTable: true,
});

export const accelerationPedalRating = createColumn({
    key: 'accelerationPedalRating',
    type: 'rating',
    dataField: 'accelerationPedalRating',
    labelId: 'discipline.accelerationPedal',
    formatter: percentageSignal.format,
    icon: 'rioglyph rioglyph-kickdown',
    hideLabelOnTable: true,
});

export const accelerationPedalRatingV2 = createColumn({
    key: 'accelerationPedalRatingV2',
    type: 'rating',
    dataField: 'accelerationPedalRatingV2',
    labelId: 'discipline.accelerationPedal',
    formatter: percentageSignal.format,
    icon: 'rioglyph rioglyph-kickdown',
    hideLabelOnTable: true,
});

export const brakingRating = createColumn({
    key: 'brakingRating',
    type: 'rating',
    dataField: 'brakingRating',
    labelId: 'discipline.braking',
    formatter: percentageSignal.format,
    icon: 'rioglyph rioglyph-brake',
    hideLabelOnTable: true,
});

export const cruiseControlRating = createColumn({
    key: 'cruiseControlRating',
    type: 'rating',
    dataField: 'cruiseControlRating',
    labelId: 'discipline.cruiseControl',
    formatter: percentageSignal.format,
    icon: 'rioglyph rioglyph-cruise-control',
    hideLabelOnTable: true,
});

export const cruiseControlRatingV2 = createColumn({
    key: 'cruiseControlRatingV2',
    type: 'rating',
    dataField: 'cruiseControlRatingV2',
    labelId: 'discipline.cruiseControl',
    formatter: percentageSignal.format,
    icon: 'rioglyph rioglyph-cruise-control',
    hideLabelOnTable: true,
});

export const cruiseControlRatingV3 = createColumn({
    key: 'cruiseControlRatingV3',
    type: 'rating',
    dataField: 'cruiseControlRatingV3',
    labelId: 'discipline.cruiseControl',
    formatter: percentageSignal.format,
    icon: 'rioglyph rioglyph-cruise-control',
    hideLabelOnTable: true,
});

export const overspeedRating = createColumn({
    key: 'overspeedRating',
    type: 'rating',
    dataField: 'overspeedRating',
    labelId: 'discipline.overspeed',
    formatter: percentageSignal.format,
    icon: 'rioglyph rioglyph-speed',
    hideLabelOnTable: true,
});

export const totalRating = createColumn({
    key: 'totalRating',
    type: 'rating',
    dataField: 'foresightedDrivingPercentage',
    labelId: 'details.rating',
    formatter: percentageSignal.format,
});

export const totalRatingWithoutCC = createColumn({
    key: 'totalRatingWithoutCC',
    type: 'rating',
    dataField: 'foresightedDrivingPercentageWithoutCc',
    labelId: 'details.rating',
    formatter: percentageSignal.format,
});

export const totalRatingV2 = createColumn({
    key: 'totalRatingV2',
    type: 'rating',
    dataField: 'foresightedDrivingPercentageV2',
    labelId: 'details.rating',
    formatter: percentageSignal.format,
});

export const fuelForesightedDrivingPercentage = createColumn({
    key: 'fuelForesightedDrivingPercentage',
    type: 'rating',
    dataField: 'foresightedDrivingPercentageV2',
    labelId: 'rating.fuel',
    formatter: percentageSignal.format,
});

export const totalRatingV3 = createColumn({
    key: 'totalRatingV3',
    type: 'rating',
    dataField: 'foresightedDrivingPercentageV3',
    labelId: 'details.rating',
    formatter: percentageSignal.format,
});

export const totalRatingWithoutCCV2 = createColumn({
    key: 'totalRatingWithoutCCV2',
    type: 'rating',
    dataField: 'foresightedDrivingPercentageWithoutCcV2',
    labelId: 'details.rating',
    formatter: percentageSignal.format,
});

export const harshAccelerationRating = createColumn({
    key: 'harshAccelerationRating',
    type: 'rating',
    dataField: 'harshAccelerationRating',
    labelId: 'discipline.harshAcceleration',
    formatter: percentageSignal.format,
    icon: 'rioglyph rioglyph-exclamation-sign',
});

export const harshBrakingRating = createColumn({
    key: 'harshBrakingRating',
    type: 'rating',
    dataField: 'harshBrakingRating',
    labelId: 'discipline.harshBraking',
    formatter: percentageSignal.format,
    icon: 'rioglyph rioglyph-dangerousgoods',
});

export const excessiveIdlingRating = createColumn({
    key: 'excessiveIdlingRating',
    type: 'rating',
    dataField: 'excessiveIdlingRating',
    labelId: 'discipline.excessiveIdling',
    formatter: percentageSignal.format,
    icon: 'rioglyph rioglyph-hour-glass',
    hideLabelOnTable: true,
});

export const electricRecuperationRating = createColumn({
    key: 'electricRecuperationRating',
    type: 'rating',
    dataField: 'electricRecuperationRating',
    labelId: 'electricRecuperation',
    formatter: percentageSignal.format,
    icon: 'rioglyph rioglyph-refresh',
    hideLabelOnTable: true,
});

export const electricAccelerationPedalRating = createColumn({
    key: 'electricAccelerationPedalRating',
    type: 'rating',
    dataField: 'electricAccelerationPedalRating',
    labelId: 'discipline.accelerationPedal',
    formatter: percentageSignal.format,
    icon: 'rioglyph rioglyph-kickdown',
    hideLabelOnTable: true,
});

export const electricOverspeedRating = createColumn({
    key: 'electricOverspeedRating',
    type: 'rating',
    dataField: 'electricOverspeedRating',
    labelId: 'discipline.overspeed',
    formatter: percentageSignal.format,
    icon: 'rioglyph rioglyph-speed',
    hideLabelOnTable: true,
});

export const electricCruiseControlRating = createColumn({
    key: 'electricCruiseControlRating',
    type: 'rating',
    dataField: 'electricCruiseControlRating',
    labelId: 'discipline.cruiseControl',
    formatter: percentageSignal.format,
    icon: 'rioglyph rioglyph-cruise-control',
    hideLabelOnTable: true,
});

export const electricForesightedDrivingPercentage = createColumn({
    key: 'electricForesightedDrivingPercentage',
    type: 'rating',
    dataField: 'electricForesightedDrivingPercentage',
    labelId: 'rating.electric',
    formatter: percentageSignal.format,
});
